import { render, staticRenderFns } from "./Final.vue?vue&type=template&id=0dc11b12&scoped=true"
import script from "./Final.vue?vue&type=script&lang=js"
export * from "./Final.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc11b12",
  null
  
)

export default component.exports